/**
 * ButterflyLoader — branded loading animation with the IMAGO butterfly logo.
 *
 * Uses a combination of float (translateY) and breathe (scale) animations
 * to create a living, organic feel. A subtle glow pulse adds depth.
 *
 * The butterfly image is a PNG/SVG placed in /public — referenced via
 * absolute path so Vite resolves it correctly in all environments.
 */

interface ButterflyLoaderProps {
  /** Logo dimensions in px (square). Default: 120 */
  size?: number
  /** Optional extra class names */
  className?: string
  /** Show "IMAGO" text below the logo. Default: true */
  showText?: boolean
}

export default function ButterflyLoader({
  size = 120,
  className = '',
  showText = true,
}: ButterflyLoaderProps) {
  return (
    <div
      className={`butterfly-loader ${className}`}
      role="status"
      aria-label="Loading"
    >
      {/* Glow layer — sits behind the logo, blurred and pulsing */}
      <div
        className="butterfly-loader__glow"
        style={{ width: size * 0.8, height: size * 0.8 }}
      />

      {/* Logo image — float + breathe animation */}
      <img
        src="/imago_logo.png"
        alt="IMAGO"
        className="butterfly-loader__logo"
        style={{ width: size, height: size }}
        draggable={false}
      />

      {/* Brand name with gradient text */}
      {showText && (
        <span className="butterfly-loader__text">IMAGO</span>
      )}
    </div>
  )
}
